import { ESignInfoSection } from "eSign/components/DocumentDetails/EsignInfoSection";
import ReadonlyProductsPanelSegment from "Products/ReadonlyProductsPanelSegment";
import React from "react";
import ReadonlyLinkedShowsPanelSegment from "../../document/linkshow/ReadonlyLinkedShowsPanelSegment";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import ESignActivityPanel from "../components/activity/ESignActivityPanel";
import ESignOptionsPanel from "../components/optionspanel/ESignOptionsPanel";
import ViewDocumentButton from "../components/ViewDocumentButton";
import ReadonlyFilesPanelSegment from "../panelsegment/ReadonlyFilesPanelSegment";
import ViewerPanelSegment from "../panelsegment/ViewerPanelSegment";
import { SenderPanel } from "eSign/panelsegment/SenderPanel";
import { SignerPanel } from "eSign/panelsegment/SignerPanel";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import NotesPanel from "note/list/app";

interface Props {
  viewModel: server.viewmodel.ESignDetailFrontModel
}

const CompletedPanel = (props: Props) => {
  const { viewModel } = props;
  const documentType = viewModel.details.documentType as Exclude<server.dto.DocumentTypes, "unknown">;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <DetailSectionTemplate
        isInPageEditable={false}
        onValueChanged={() => { }}
        sections={[
          {
            type: "custom",
            key: "infoSection",
            render: () => <ESignInfoSection
              documentType={documentType}
              esignDocument={viewModel.details}
              stepOptions={{
                draft: { disabled: true },
                review: { disabled: true },
                pending: { disabled: true },
                completed: { disabled: false }
              }}
              overDue={false}
              activeStep="completed"
              brands={viewModel.brands}
            />
          },
          SenderPanel({
            esignDocument: viewModel.details,
            sender: viewModel.sender,
            progress: viewModel.senderProgress,
          }),
          SignerPanel({
            esignDocument: viewModel.details,
            signer: viewModel.signer,
            progress: viewModel.signerProgress
          }),
          {
            type: "custom",
            key: "viewDocumentButton",
            render: () => <ViewDocumentButton
              documentNumber={viewModel.details.documentNumber}
              label={RESX.ESign.ViewDocument}
              version={viewModel.details.version}
              documentId={viewModel.details.documentId}
            />
          },
          {
            type: "custom",
            key: "viewPanel",
            render: () => <ViewerPanelSegment
              initialViewers={viewModel.viewers}
              document={viewModel.details}
            />
          },
          {
            key: "otherFilesPanel",
            type: "custom",
            render: () => <ReadonlyFilesPanelSegment
              label={RESX.ESign.OtherFiles}
              files={viewModel.otherFiles}
            />
          },
          {
            type: "custom",
            key: "productsPanel",
            render: () => <ReadonlyProductsPanelSegment
              productsPanel={viewModel.productsPanel}
            />
          },
          {
            type: "custom",
            key: "linkedShowsPanel",
            render: () => <ReadonlyLinkedShowsPanelSegment
              documentType={viewModel.details.documentType}
              linkedShowsPanel={viewModel.linkedShowsPanel}
            />
          }, {
            key: "notesPanel",
            type: "custom",
            render: () => <NotesPanel
              mainArea={documentType}
              useSectionPanel
              config={viewModel.linkedNotePanelConfig}
            />
          }
        ]}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn size="medium">
      <ESignOptionsPanel
        optionsPanel={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        documentDetails={viewModel.details}
        copyUrl={viewModel.copyUrl}
      />

      <ESignActivityPanel
        documentId={viewModel.details.documentId}
        config={viewModel.activityPanel}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default CompletedPanel;